import { Link } from 'react-router-dom';
import { getHotResources } from '@/mocks/resources';
import { categoryMap } from '@/mocks/categories';

export default function HotResources() {
  const hotResources = getHotResources(8);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门资源
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              做种人数最多、下载速度最快的热门资源
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {hotResources.map((resource) => {
            const cat = categoryMap[resource.category];
            const seedRatio = resource.seeders / (resource.seeders + resource.leechers) * 100;
            return (
              <Link
                key={resource.id}
                to={`/article/${resource.id}`}
                className="bg-background-50 rounded-xl p-5 transition-all duration-200 hover:bg-background-100 cursor-pointer group"
              >
                <div className="flex items-start justify-between mb-3">
                  <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-xs font-medium">
                    {cat?.name || resource.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{resource.date}</span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {resource.title}
                </h3>
                <div className="flex items-center gap-4 text-xs text-foreground-400 mb-3">
                  <span className="flex items-center gap-1">
                    <i className="ri-hard-drive-3-line"></i>
                    {resource.size}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-file-line"></i>
                    {resource.fileCount}个文件
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="flex items-center gap-1 text-xs text-accent-600 font-medium">
                      <i className="ri-arrow-up-circle-fill text-sm"></i>
                      {resource.seeders.toLocaleString()}
                    </span>
                    <span className="flex items-center gap-1 text-xs text-foreground-400">
                      <i className="ri-arrow-down-circle-fill text-sm"></i>
                      {resource.leechers.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <div className="w-16 h-1.5 bg-background-200 rounded-full overflow-hidden">
                      <div
                        className="h-full bg-accent-500 rounded-full"
                        style={{ width: `${seedRatio}%` }}
                      ></div>
                    </div>
                    <span className="text-xs text-accent-600 font-medium">{Math.round(seedRatio)}%</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}